import { Fragment, useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Tooltip } from "react-tooltip";

import { CrownCaseDetailsSection as CrownCaseDetailsSectionV2 } from "../../Components/Order-Comps/CrownCaseDetailsSectionV2";
import UploadPhotoGraphsSectionV2 from "../../Components/Order-Comps/UploadPhotoGraphsSectionV2";
import { PatientDetailsSection as PatientDetailsSectionV2 } from "../../Components/Order-Comps/PatientDetailsSectionV2";
import { DisclaimerSection as DisclaimerSectionV2 } from "../../Components/Order-Comps/DisclaimerSectionV2";
import CrownOrderConfirmation from "../OrderConfirmation/CrownOrderConfirmation";
import Notification from "../../Components/Notification/Notification";
import Navbar from "../../Components/Navbar-Comps/Navbar";
import { LoginButton } from "../Login/Login";

import {
  useDeleteOrderMissingTeethMutation,
  useDeleteOrderServiceDetailsMutation,
  useDeleteOrderServiceMultiFieldMutation,
  useDeleteOrderServiceTeethMutation,
  useGetOrdersForDentistMutation,
  useSaveOrderDisclaimerMutation,
  useSaveOrderMissingTeethMutation,
  useSaveOrderMutation,
  useSaveOrderPatientMutation,
  useSaveOrderServiceMultiFieldMutation,
  useSaveOrderServiceTeethMutation,
  useSaveOrderServiceDetailsMutation,
  useUpdateOrderDisclaimerMutation,
  useUpdateOrderMutation,
  useUpdateOrderPatientMutation,
  useUpdateOrderServiceDetailsMutation,
} from "../../services/orders";
import { useGetServicesCategoriesMutation } from "../../services/servicesCategory";

import {
  iconArray,
  navActiveCss,
  navHoverCss,
  spIconArray,
  superAdminIconArray,
} from "../../constants/NavbarRoutesArray";
import {
  ORDER_STAGE,
  OPTIONS_VALUE,
  SERVICE_TEETH_MAPPING,
  SERVICE_TEETH_MAPPING_REVERSE,
} from "../../constants/orderForms";
import { crownTermsAndConditions } from "../../constants/OrderFormsDisclaimers";
import {
  setCrownAndBridgeOrderDetails,
  setOrderFormLastProgressTab,
} from "../../reducers/orderFormReducer";
import { crownAndBridgeInitialOrderDetails } from "../../Utils/orderFormInitialDetails";
import { checkObjects, getServicePriceRange, mergeActiveServiceOption, scrollToTop } from "../../Utils/utility";

import { FaAngleRight } from "react-icons/fa";
import { AiOutlineCheck } from "react-icons/ai";
import greenTick from "../../Assets/images/greenTick.svg";
import redCross from "../../Assets/images/redCross.svg";
import logo from "../../Assets/images/LOGO.svg";
import hut from "../../Assets/images/hut.svg";
import { GetToast } from "../../Components/Toast-Comps/GetToast";
import PriceSlip from "./PriceSlip";

function CrownAndBridgeOrderDetailsV2({ userRole, userInfo }) {
  const location = useLocation();
  console.log("location.state5", location.state);
  return (
    <div className="flex bg-black">
      <Navbar
        iconArray={
          userRole === "89uij7"
            ? superAdminIconArray
            : userRole === "676dza2"
            ? iconArray
            : spIconArray
        }
        navHoverCss={navHoverCss}
        navActiveCss={navActiveCss}
        middleSection={false}
        middleTabTitleArray={[""]}
        middleTabContentObject={{}}
        userRole={userRole}
        active="Orders"
      />
      <OrderDetailsTab
        orderObjId={location?.state?.orderObjId ?? ""}
        categoryObjId={location?.state?.categoryObjId ?? ""}
        orderByIdData={location?.state?.orderByData ?? {}}
        userInfo={userInfo}
        userRole={userRole}
      />
    </div>
  );
}

export default CrownAndBridgeOrderDetailsV2;

export const OrderDetailsTab = ({
  userRole,
  userInfo,
  categoryObjId,
  orderByIdData,
  orderObjId,
}) => {
  const dispatch = useDispatch();
  const [updateOrder] = useUpdateOrderMutation();
  const [saveOrder] = useSaveOrderMutation();
  const [saveOrderPatient] = useSaveOrderPatientMutation();
  const [updateOrderPatient] = useUpdateOrderPatientMutation();
  const [saveOrderDisclaimer] = useSaveOrderDisclaimerMutation();
  const [saveOrderMissingTeeth] = useSaveOrderMissingTeethMutation();
  const [deleteOrderMissingTeeth] = useDeleteOrderMissingTeethMutation();
  const [getOrdersForDentist] = useGetOrdersForDentistMutation();
  const [updateOrderDisclaimer] = useUpdateOrderDisclaimerMutation();
  const [saveOrderServiceDetails] = useSaveOrderServiceDetailsMutation();
  const [updateOrderServiceDetails] = useUpdateOrderServiceDetailsMutation();
  const [deleteOrderServiceDetails] = useDeleteOrderServiceDetailsMutation();
  const [saveOrderServiceTeeth] = useSaveOrderServiceTeethMutation();
  const [deleteOrderServiceTeeth] = useDeleteOrderServiceTeethMutation();
  const [saveOrderServiceMultiField] = useSaveOrderServiceMultiFieldMutation();
  const [deleteOrderServiceMultiField] = useDeleteOrderServiceMultiFieldMutation();
  const [orderByData, setOrderByData] = useState(orderByIdData);
  const { userProfileDetails } = useSelector((state) => state.personalDetails);
  const { crownAndBridgeOrderDetails, orderFormLastProgressTab } = useSelector(
    (state) => state.orderFormDetails
  );

  console.log("crownAndBridgeOrderDetails", crownAndBridgeOrderDetails);
  console.log("orderByData1", orderByData);
  console.log("orderByData2", orderByIdData);

  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isDisclaimerAccepted, setIsDisclaimerAccepted] = useState(false);
  const [selectedServiceCategory, setSelectedServiceCategory] = useState({});
  const [isTncChecked, setIsTncChecked] = useState(false);
  const [disclaimerFileUrl, setDisclaimerFileUrl] = useState(null);
  const [isDisclaimerFormValid, setIsDisclaimerFormValid] = useState(true);
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const effectiveCategoryObjId =
    categoryObjId ||
    orderByData?.categoryObjId?.[0] ||
    orderByData?.categoryObjId ||
    crownAndBridgeOrderDetails?.categoryObjId?.[0] ||
    crownAndBridgeOrderDetails?.categoryObjId ||
    "";

  const normalizePatientDetails = (orderDetails = {}) => ({
    patientInitials: orderDetails?.patientDetails?.patientInitials || "",
    detailsAnonymized: orderDetails?.patientDetails?.detailsAnonymized || false,
    dob: orderDetails?.patientDetails?.dob || "",
    gender: orderDetails?.patientDetails?.gender || "",
    address: orderDetails?.patientDetails?.address || "",
    country: orderDetails?.patientDetails?.country || "",
    pinCode: orderDetails?.patientDetails?.pinCode || "",
    location: {
      lat: orderDetails?.patientDetails?.latitude
        ? parseInt(orderDetails?.patientDetails?.latitude)
        : "",
      lng: orderDetails?.patientDetails?.longitude
        ? parseInt(orderDetails?.patientDetails?.longitude)
        : "",
    },
  });

  const normalizeCaseDetails = (orderDetails = {}) => ({
    numberSystem: orderDetails?.numberSystem || "",
    hasMissingTeeth:
      orderDetails?.hasMissingTeeth !== undefined && orderDetails?.hasMissingTeeth !== null
        ? orderDetails?.hasMissingTeeth
        : (orderDetails?.missingTeeth || [])?.some((item) => item?.expiryDate == null)
        ? true
        : null,
    missingTeethSelectedTeeth: (orderDetails?.missingTeeth || [])?.reduce((acc, item) => {
      if (item?.expiryDate == null) {
        acc.push(item?.teethno);
      }
      return acc;
    }, []),
    anyTeethMobile:
      orderDetails?.anyTeethMobile !== undefined ? orderDetails?.anyTeethMobile : null,
    anyTeethMobileSelectedTeeth: (orderDetails?.anyTeethMobileDet || [])?.reduce((acc, item) => {
      if (item?.expiryDate == null) {
        acc.push(item?.teethno);
      }
      return acc;
    }, []),
    teethToExtract: orderDetails?.teethToExtract !== undefined ? orderDetails?.teethToExtract : null,
    teethToExtractSelectedTeeth: (orderDetails?.teethToExtractDet || [])?.reduce((acc, item) => {
      if (item?.expiryDate == null) {
        acc.push(item?.teethno);
      }
      return acc;
    }, []),
    services: (orderDetails?.services || []).reduce((acc, item) => {
      const serviceTooths = item?.serviceTooth
        ?.filter((toothItem) => toothItem?.expiryDate == null)
        ?.reduce((prevAcc, toothItem) => {
          const field = SERVICE_TEETH_MAPPING_REVERSE[toothItem.type];
          if (!field) return prevAcc;
          prevAcc[field] = [
            ...(prevAcc?.[field] || []),
            toothItem.teethno,
          ];
          return prevAcc;
        }, {});
      const serviceOptions = item?.serviceOptions?.reduce(mergeActiveServiceOption, {});
      acc.push({ ...item, ...serviceTooths, ...serviceOptions });
      return acc;
    }, []),
  });

  const normalizedOrderSnapshot = useMemo(() => {
    if (!orderByData?._id) {
      return null;
    }

    return {
      ...orderByData,
      patientDetails: normalizePatientDetails(orderByData),
      caseDetails: normalizeCaseDetails(orderByData),
    };
  }, [orderByData]);

  const tabNamesArray = [
    ORDER_STAGE.PATIENT_DETAILS,
    ORDER_STAGE.CASE_DETAILS,
    ORDER_STAGE.UPLOAD_FILES,
    ORDER_STAGE.DISCLAIMER,
  ];

  const isBlank = (value) => value === undefined || value === null || `${value}`.trim() === "";

  const validatePatientDetailsPayload = (data) => {
    const requiredFields = [
      ["patientInitials", "Patient Initials"],
      ["dob", "Patient Date of Birth"],
      ["gender", "Gender"],
      ["address", "Shipping Address"],
      ["country", "Country"],
      ["pinCode", "Postal code"],
      ["spLevelObjId", "Preferred Service Provider Level"],
    ];

    const missingField = requiredFields.find(([key]) => isBlank(data?.[key]));
    if (missingField) {
      GetToast(`Please complete ${missingField[1]}`, "error");
      return false;
    }
    return true;
  };

  const validateCaseDetailsPayload = (data) => {
    if (!data?.hasMissingTeeth) {
      GetToast("Please confirm whether the patient has missing teeth", "error");
      return false;
    }

    if (data?.hasMissingTeeth === "Yes" && !(data?.missingTeethSelectedTeeth?.length > 0)) {
      GetToast("Please select at least one missing tooth", "error");
      return false;
    }

    if (!(data?.services?.length > 0)) {
      GetToast("Please select at least one restorative service", "error");
      return false;
    }

    const crownTypeLabels = [
      "Single or Multiple single crowns",
      "Bridge(s)",
      "Bridge(s) with gingiva",
      "Maryland Bridge",
      "Veneers",
      "Onlays",
      "Post and core crown",
    ];

    const invalidService = (data?.services || []).find((service) => {
      if (!(service?.serviceName || "").length) return false;

      if (
        (service?.serviceName === "Bridge(s)" ||
          service?.serviceName === "Bridge(s) with gingiva" ||
          service?.serviceName === "Maryland Bridge" ||
          crownTypeLabels.includes(service?.serviceName)) &&
        !(service?.restorationSites?.length > 0)
      ) {
        return true;
      }

      const hasRequiredContacts =
        [
          "Single or Multiple single crowns",
          "Bridge(s)",
          "Bridge(s) with gingiva",
          "Maryland Bridge",
          "Veneers",
          "Onlays",
          "Post and core crown",
        ].includes(service?.serviceName) || Boolean(service?.interproximalContacts);

      if (hasRequiredContacts) {
        if (isBlank(service?.interproximalContacts)) return true;
        if (isBlank(service?.occlusalContacts)) return true;
        if (isBlank(service?.needDesignPreview)) return true;
        if (isBlank(service?.processType)) return true;
        if (isBlank(service?.designFileNeeded)) return true;
        if (isBlank(service?.preferredSoftware)) return true;
        if (isBlank(service?.constructionFileNeeded)) return true;
        if (isBlank(service?.printableModelRequired)) return true;
        if (isBlank(service?.restorationLacksOC)) return true;
      }

      return false;
    });

    if (invalidService) {
      GetToast(
        `Please complete all required fields for ${invalidService?.serviceName || "the selected service"}`,
        "error"
      );
      return false;
    }

    return true;
  };

  const validateUploadPayload = (data) => {
    const hasAnyPhoto = Object.values(data?.photographs || {}).some((item) => item?.s3Url);
    const hasAnyRadiograph = Object.values(data?.radiographs || {}).some((item) => item?.s3Url);
    const hasAnyIntraOral = Object.values(data?.intraOralScans || {}).some((item) => item?.s3Url);
    const hasAnyDicom = Object.values(data?.rawDicomData || {}).some((item) => item?.s3Url);

    if (!hasAnyPhoto) {
      GetToast("Please upload at least one photograph", "error");
      return false;
    }
    if (!hasAnyRadiograph) {
      GetToast("Please upload at least one radiograph", "error");
      return false;
    }
    if (!hasAnyIntraOral) {
      GetToast("Please upload at least one intra oral scan", "error");
      return false;
    }
    if (!hasAnyDicom) {
      GetToast("Please upload at least one raw DICOM file", "error");
      return false;
    }
    if (isBlank(data?.scanMedium)) {
      GetToast("Please select how the intraoral scans were sent", "error");
      return false;
    }

    return true;
  };

  const validateDisclaimerPayload = () => {
    if (!isTncChecked) {
      GetToast("Please accept the terms and conditions", "error");
      return false;
    }
    return true;
  };

  const normalizeNumberArray = (values = []) =>
    [...new Set((values || []).map((value) => Number(value)).filter((value) => !Number.isNaN(value)))].sort(
      (a, b) => a - b
    );

  const getValueCounts = (values = []) =>
    (values || []).reduce((acc, value) => {
      const key = `${value}`;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

  const getArrayDiff = (previous = [], next = []) => {
    const previousNormalized = normalizeNumberArray(previous);
    const nextNormalized = normalizeNumberArray(next);
    const previousSet = new Set(previousNormalized);
    const nextSet = new Set(nextNormalized);
    return {
      added: nextNormalized.filter((item) => !previousSet.has(item)),
      removed: previousNormalized.filter((item) => !nextSet.has(item)),
    };
  };

  const normalizeExistingService = (service) => {
    const serviceTooths = service?.serviceTooth
      ?.filter((toothItem) => toothItem?.expiryDate == null)
      ?.reduce((prevAcc, toothItem) => {
        const field = SERVICE_TEETH_MAPPING_REVERSE[toothItem.type];
        if (!field) return prevAcc;
        prevAcc[field] = [
          ...(prevAcc?.[field] || []),
          toothItem.teethno,
        ];
        return prevAcc;
      }, {});
    const serviceOptions = service?.serviceOptions?.reduce(mergeActiveServiceOption, {});

    return { ...service, ...serviceTooths, ...serviceOptions };
  };

  const getExistingServiceFieldCounts = (existingService, fieldKey) => {
    if (fieldKey === "typeOfCrown" || fieldKey === "typeOfVeneer") {
      return getValueCounts(
        existingService?.serviceOptions
          ?.filter((item) => item?.expiryDate == null)
          ?.filter((item) => item?.type === fieldKey)
          ?.map((item) => item?.optionstring)
      );
    }

    const serviceType = SERVICE_TEETH_MAPPING?.[fieldKey];
    return getValueCounts(
      existingService?.serviceTooth
        ?.filter((item) => item?.expiryDate == null)
        ?.filter((item) => item?.type === serviceType)
        ?.map((item) => item?.teethno)
    );
  };

  const getMissingTeethSelection = (missingTeeth = []) => {
    return (missingTeeth || []).reduce((acc, item) => {
      if (item?.expiryDate == null) {
        acc.push(item?.teethno);
      }
      return acc;
    }, []);
  };

  const persistServiceDraft = async (accessToken, service) => {
    const existingService = orderByData?.services?.find(
      (item) => item?.serviceObjId === service?.serviceObjId
    );
    const normalizedExistingService = normalizeExistingService(existingService);
    const serviceExists = Boolean(existingService?.serviceObjId);

    if (!serviceExists) {
      await saveOrderServiceDetails({
        accessToken,
        _id: crownAndBridgeOrderDetails?._id,
        serviceObjId: service?.serviceObjId,
        cementGap: service?.cementGap,
        interproximalContacts: service?.interproximalContacts,
        occlusalContacts: service?.occlusalContacts,
        processType: service?.processType,
        processTypePreferredRestorativeSpace: service?.processTypePreferredRestorativeSpace,
        printableModelRequired: service?.printableModelRequired,
        printableModelincludeDies: service?.printableModelincludeDies,
        ponticDesign: service?.ponticDesign,
        needDesignPreview: service?.needDesignPreview,
        designFileNeeded: service?.designFileNeeded,
        preferredSoftware: service?.preferredSoftware,
        constructionFileNeeded: service?.constructionFileNeeded,
        restorationLacksOC: service?.restorationLacksOC,
        additionalInstructions: service?.additionalInstructions,
      }).unwrap();
    } else if (!checkObjects(service, normalizedExistingService)) {
      await updateOrderServiceDetails({
        accessToken,
        _id: crownAndBridgeOrderDetails?._id,
        serviceObjId: service?.serviceObjId,
        cementGap: service?.cementGap,
        interproximalContacts: service?.interproximalContacts,
        occlusalContacts: service?.occlusalContacts,
        processType: service?.processType,
        processTypePreferredRestorativeSpace: service?.processTypePreferredRestorativeSpace,
        printableModelRequired: service?.printableModelRequired,
        printableModelincludeDies: service?.printableModelincludeDies,
        ponticDesign: service?.ponticDesign,
        needDesignPreview: service?.needDesignPreview,
        designFileNeeded: service?.designFileNeeded,
        preferredSoftware: service?.preferredSoftware,
        constructionFileNeeded: service?.constructionFileNeeded,
        restorationLacksOC: service?.restorationLacksOC,
        additionalInstructions: service?.additionalInstructions,
      }).unwrap();
    }

    const teethFields = Object.keys(SERVICE_TEETH_MAPPING || {});
    for (const teethField of teethFields) {
      const existingCounts = getExistingServiceFieldCounts(existingService, teethField);
      const nextCounts = getValueCounts(normalizeNumberArray(service?.[teethField] || []));
      const teethNumbers = new Set([
        ...Object.keys(existingCounts || {}),
        ...Object.keys(nextCounts || {}),
      ]);

      for (const teethnoKey of teethNumbers) {
        const existingCount = existingCounts?.[teethnoKey] || 0;
        const nextCount = nextCounts?.[teethnoKey] || 0;
        const delta = nextCount - existingCount;
        const teethno = Number(teethnoKey);

        if (delta > 0) {
          for (let i = 0; i < delta; i += 1) {
            await saveOrderServiceTeeth({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              teethno,
              serviceObjId: service?.serviceObjId,
              type: SERVICE_TEETH_MAPPING?.[teethField],
            }).unwrap();
          }
        } else if (delta < 0) {
          for (let i = 0; i < Math.abs(delta); i += 1) {
            await deleteOrderServiceTeeth({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              teethno,
              serviceObjId: service?.serviceObjId,
              type: SERVICE_TEETH_MAPPING?.[teethField],
            }).unwrap();
          }
        }
      }
    }

    const optionFields = ["typeOfCrown", "typeOfVeneer"];
    for (const optionField of optionFields) {
      const existingCounts = getExistingServiceFieldCounts(existingService, optionField);
      const nextCounts = getValueCounts(service?.[optionField] || []);
      const optionValues = new Set([
        ...Object.keys(existingCounts || {}),
        ...Object.keys(nextCounts || {}),
      ]);

      for (const optionstring of optionValues) {
        const existingCount = existingCounts?.[optionstring] || 0;
        const nextCount = nextCounts?.[optionstring] || 0;
        const delta = nextCount - existingCount;

        if (delta > 0) {
          for (let i = 0; i < delta; i += 1) {
            await saveOrderServiceMultiField({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              serviceObjId: service?.serviceObjId,
              type: optionField,
              optionstring,
            }).unwrap();
          }
        } else if (delta < 0) {
          for (let i = 0; i < Math.abs(delta); i += 1) {
            await deleteOrderServiceMultiField({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              serviceObjId: service?.serviceObjId,
              type: optionField,
              optionstring,
            }).unwrap();
          }
        }
      }
    }
  };

  const getExistingOrderDetails = async (orderObjId) => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
      },
    });

    const newresp = await getOrdersForDentist({
      accessToken,
      data: { _id: orderObjId || orderByData?._id },
    }).unwrap();
    const orderDetails = newresp?.data?.[0];
    if (orderDetails) {
      const missingTeethSelectedTeeth = getMissingTeethSelection(orderDetails?.missingTeeth);
      const normalizedOrderDetails = {
        ...orderDetails,
        patientDetails: normalizePatientDetails(orderDetails),
        caseDetails: normalizeCaseDetails(orderDetails),
      };
      dispatch(
        setCrownAndBridgeOrderDetails({
          ...normalizedOrderDetails,
          expectedDelivery: orderDetails?.expectedDelivery || "",
          categoryObjId:
            orderDetails?.categoryObjId?.[0] ||
            orderDetails?.categoryObjId ||
            effectiveCategoryObjId,
          isPriority: orderDetails?.isPriority !== undefined ? orderDetails?.isPriority : null,
          caseDetails: {
            ...normalizedOrderDetails.caseDetails,
            hasMissingTeeth:
              orderDetails?.hasMissingTeeth !== undefined && orderDetails?.hasMissingTeeth !== null
                ? orderDetails?.hasMissingTeeth
                : missingTeethSelectedTeeth.length > 0
                ? true
                : null,
            missingTeethSelectedTeeth,
          },
          uploadFiles: {
            photographs: (orderDetails?.assets || [])?.reduce((acc, item) => {
              if (item?.fileType === "photograhpsAndFaceScans") {
                acc[item?.fileFor] = {
                  fileType: item?.fileType || "",
                  s3Url: item?.s3Url || "",
                  _id: item?._id || "",
                };
              }
              return acc;
            }, {}),
            radiographs: (orderDetails?.assets || [])?.reduce((acc, item) => {
              if (item?.fileType === "radiographs") {
                acc[item?.fileFor] = {
                  fileType: item?.fileType || "",
                  s3Url: item?.s3Url || "",
                  _id: item?._id || "",
                };
              }
              return acc;
            }, {}),
            intraOralScans: (orderDetails?.assets || [])?.reduce((acc, item) => {
              if (item?.fileType === "internalScan") {
                acc[item?.fileFor] = {
                  fileType: item?.fileType || "",
                  s3Url: item?.s3Url || "",
                  _id: item?._id || "",
                };
              }
              return acc;
            }, {}),
            rawDicomData: (orderDetails?.assets || [])?.reduce((acc, item) => {
              if (item?.fileType === "rawDicom") {
                acc[item?.fileFor] = {
                  fileType: item?.fileType || "",
                  s3Url: item?.s3Url || "",
                  _id: item?._id || "",
                };
              }
              return acc;
            }, {}),
            additionalFiles: (orderDetails?.assets || [])?.reduce((acc, item) => {
              if (item?.fileType === "additionalFiles") {
                acc[item?.fileFor] = {
                  fileType: item?.fileType || "",
                  s3Url: item?.s3Url || "",
                  _id: item?._id || "",
                };
              }
              return acc;
            }, {}),
          },
          disclaimers: {
            isTncChecked: orderDetails?.isTncChecked || false,
            tncDocument: orderDetails?.tncDocument || null,
          },
        })
      );
      setOrderByData(normalizedOrderDetails);
    }
  };

  useEffect(() => {
    if (orderObjId) {
      getExistingOrderDetails(orderObjId);
    }
  }, [orderObjId]);

  const [activeTab, setActiveTab] = useState(tabNamesArray[0]);
  const [priceRange, setPriceRange] = useState(null);

  const [getServicesCategories] = useGetServicesCategoriesMutation();
  const getServicesCategoriesData = async (accessToken) => {
    const resp = await getServicesCategories(accessToken).unwrap();
    if (resp?.data && effectiveCategoryObjId) {
      resp?.data?.forEach((d) => {
        if (d?._id === effectiveCategoryObjId) {
          setSelectedServiceCategory(d);
          setPriceRange(getServicePriceRange(d?.catservices));
        }
      });
    }
  };

  const readServicesInfo = async () => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
      },
    });
    await getServicesCategoriesData(accessToken);
  };

  useEffect(() => {
    if (orderByData?._id) {
      dispatch(
        setCrownAndBridgeOrderDetails({
          ...crownAndBridgeOrderDetails,
          categoryObjId: effectiveCategoryObjId,
          _id: orderByData?._id,
        })
      );
    }
  }, [orderByData, effectiveCategoryObjId]);

  useEffect(() => {
    readServicesInfo();

    return () => {
      dispatch(setCrownAndBridgeOrderDetails(crownAndBridgeInitialOrderDetails));
      dispatch(setOrderFormLastProgressTab(0));
    };
    // Re-run once the order/category data is available so the service carousel can hydrate.
  }, [effectiveCategoryObjId]);

  const fetchOrderDetails = async (accessToken) => {
    const newresp = await getOrdersForDentist({
      accessToken,
      data: { _id: orderByData?._id },
    });
    const latestOrder = newresp?.data?.[0] || newresp?.data?.data?.[0];
    if (latestOrder) setOrderByData(latestOrder);
  };

  const submitPatientDetails = async (data) => {
    const { isPriority, expectedDelivery, spLevelObjId, ...patientDetails } = data;
    if (!validatePatientDetailsPayload(data)) {
      return false;
    }
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
        },
      });
      let resp;
      const requestList = [];
      if (crownAndBridgeOrderDetails?._id) {
        requestList.push(
          updateOrder({
            accessToken,
            data: {
              _id: crownAndBridgeOrderDetails?._id,
              isPriority: isPriority,
              expectedDelivery: expectedDelivery,
              spLevelObjId: spLevelObjId,
            },
          })
        );
        if (orderByData?.patientDetails) {
          requestList.push(
            updateOrderPatient({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              patientInitials: patientDetails?.patientInitials,
              detailsAnonymized: patientDetails?.detailsAnonymized,
              dob: patientDetails?.dob,
              gender: patientDetails?.gender,
              address: patientDetails?.address,
              country: patientDetails?.country,
              pinCode: patientDetails?.pinCode,
              latitude: patientDetails?.location?.lat,
              longitude: patientDetails?.location?.lng,
            })
          );
        } else {
          requestList.push(
            saveOrderPatient({
              accessToken,
              _id: crownAndBridgeOrderDetails?._id,
              patientInitials: patientDetails?.patientInitials,
              detailsAnonymized: patientDetails?.detailsAnonymized,
              dob: patientDetails?.dob,
              gender: patientDetails?.gender,
              address: patientDetails?.address,
              country: patientDetails?.country,
              pinCode: patientDetails?.pinCode,
              latitude: patientDetails?.location?.lat,
              longitude: patientDetails?.location?.lng,
            })
          );
        }
        dispatch(
          setCrownAndBridgeOrderDetails({
            ...crownAndBridgeOrderDetails,
            isPriority: isPriority,
            expectedDelivery: expectedDelivery,
            spLevelObjId: spLevelObjId,
            patientDetails: patientDetails,
          })
        );
        await Promise.all(requestList);
        await fetchOrderDetails(accessToken);
      } else {
        resp = await saveOrder({
          accessToken,
          data: {
            isPriority: isPriority,
            expectedDelivery: expectedDelivery,
            spLevelObjId: spLevelObjId,
            categoryObjId: effectiveCategoryObjId,
          },
        }).unwrap();
        await saveOrderPatient({
          accessToken,
          _id: resp?.data?.data?.[0]?._id,
          patientInitials: patientDetails?.patientInitials,
          detailsAnonymized: patientDetails?.detailsAnonymized,
          dob: patientDetails?.dob,
          gender: patientDetails?.gender,
          address: patientDetails?.address,
          country: patientDetails?.country,
          pinCode: patientDetails?.pinCode,
          latitude: patientDetails?.location?.lat,
          longitude: patientDetails?.location?.lng,
        });
        dispatch(
          setCrownAndBridgeOrderDetails({
            ...crownAndBridgeOrderDetails,
            _id: resp?.data?.data?.[0]?._id,
            isPriority: isPriority,
            expectedDelivery: expectedDelivery,
            spLevelObjId: spLevelObjId,
            patientDetails: patientDetails,
          })
        );
        await fetchOrderDetails(accessToken);
      }
      dispatch(setOrderFormLastProgressTab(1));
      return true;
    } catch (error) {
      console.error("submitPatientDetails failed", error);
      GetToast("Unable to save patient details. Please try again.", "error");
      return false;
    }
  };

  const submitDisclaimerForm = () => {
    const isTncCheckedValid = !isFieldRequired("tnc") || isTncChecked;
    setIsDisclaimerFormValid(isTncCheckedValid);

    if (isTncCheckedValid && validateDisclaimerPayload()) {
      console.log("submit the form");
      return submitDisclaimerData({
        isTncChecked: isTncChecked,
        tncDocument: disclaimerFileUrl,
      });
    } else {
      console.log("not checked");
      return false;
    }
  };

  console.log("crownAndBridgeOrderDetails", crownAndBridgeOrderDetails);

  const submitDisclaimerData = async (data) => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
      },
    });
    if (crownAndBridgeOrderDetails?.tncDocument) {
      await updateOrderDisclaimer({
        accessToken: accessToken,
        _id: crownAndBridgeOrderDetails?._id,
        isTncChecked: data?.isTncChecked,
        tncDocument: data?.tncDocument,
      });
    } else {
      await saveOrderDisclaimer({
        accessToken: accessToken,
        _id: crownAndBridgeOrderDetails?._id,
        isTncChecked: data?.isTncChecked,
        tncDocument: data?.tncDocument,
      });
    }
    dispatch(
      setCrownAndBridgeOrderDetails({
        ...crownAndBridgeOrderDetails,
        disclaimers: data,
      })
    );
    setIsDisclaimerAccepted(true);
  };

  const submitCaseDetails = async (data) => {
    if (!validateCaseDetailsPayload(data)) {
      return false;
    }

    dispatch(
      setCrownAndBridgeOrderDetails({
        ...crownAndBridgeOrderDetails,
        caseDetails: data,
      })
    );

    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
      },
    });

    const requestList = [];
    const savedServiceIds = (orderByData?.services || [])
      .map((service) => service?.serviceObjId)
      .filter(Boolean);
    const currentServiceIds = (data?.services || [])
      .map((service) => service?.serviceObjId)
      .filter(Boolean);
    const removedServiceIds = savedServiceIds.filter(
      (serviceObjId) => !currentServiceIds.includes(serviceObjId)
    );
    const existingMissingTeeth = (orderByData?.missingTeeth || [])?.reduce((acc, item) => {
      if (item?.expiryDate == null) {
        acc.push(item?.teethno);
      }
      return acc;
    }, []);

    requestList.push(
      updateOrder({
        accessToken,
        data: {
          _id: crownAndBridgeOrderDetails?._id,
          hasMissingTeeth: data?.hasMissingTeeth,
          numberSystem: data?.numberSystem,
        },
      }).unwrap()
    );

    removedServiceIds.forEach((serviceObjId) => {
      requestList.push(
        deleteOrderServiceDetails({
          accessToken,
          _id: crownAndBridgeOrderDetails?._id,
          serviceObjId,
        }).unwrap()
      );
    });

    const missingTeethDiff = getArrayDiff(existingMissingTeeth, data?.missingTeethSelectedTeeth || []);
    missingTeethDiff.added.forEach((teethno) => {
      requestList.push(
        saveOrderMissingTeeth({
          accessToken,
          _id: crownAndBridgeOrderDetails?._id,
          teethno,
        }).unwrap()
      );
    });
    missingTeethDiff.removed.forEach((teethno) => {
      requestList.push(
        deleteOrderMissingTeeth({
          accessToken,
          _id: crownAndBridgeOrderDetails?._id,
          teethno,
        }).unwrap()
      );
    });

    data?.services?.forEach((service) => {
      requestList.push(persistServiceDraft(accessToken, service));
    });

    try {
      await Promise.all(requestList);
      await getExistingOrderDetails(orderByData?._id);
      dispatch(setOrderFormLastProgressTab(2));
      return true;
    } catch (error) {
      console.error("submitCaseDetails failed", error);
      GetToast("Unable to save order details. Please try again.", "error");
      return false;
    }
  };

  const submitUploadData = async (data) => {
    const { scanMedium, ...uploadData } = data;
    if (!validateUploadPayload(data)) {
      return;
    }
    if (scanMedium && scanMedium !== orderByData?.scanMedium) {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
        },
      });
      updateOrder({
        accessToken,
        data: {
          _id: orderByData?._id,
          scanMedium: scanMedium,
        },
      });
    }
    dispatch(
      setCrownAndBridgeOrderDetails({
        ...crownAndBridgeOrderDetails,
        scanMedium: scanMedium,
        uploadFiles: uploadData,
      })
    );

    dispatch(setOrderFormLastProgressTab(3));
  };

  const placeOrderHandler = async () => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUDIENCE_URL, // Value in Identifier field for the API being called.
      },
    });
    let resp;
    resp = await updateOrder({
      accessToken,
      data: {
        _id: crownAndBridgeOrderDetails?._id,
        isPriority: crownAndBridgeOrderDetails?.isPriority,
        expectedDelivery: crownAndBridgeOrderDetails?.expectedDelivery,
        categoryObjId: crownAndBridgeOrderDetails?.categoryObjId,
        currentStatus: "1",
      },
    }).unwrap();
    if (resp) {
      GetToast(resp["message"]);
    }
    setIsOrderPlaced(true);
  };

  const isFieldRequired = (fieldName) => {
    const requiredFields = ["intraOralScans", "tnc"];

    return requiredFields.includes(fieldName);
  };

  const handleTabSuper = (tabName) => {
    scrollToTop();
    setActiveTab(tabName);
  };

  const outputObject = {
    [ORDER_STAGE.PATIENT_DETAILS]: (
      <PatientDetailsSectionV2
        key={`patient-${orderByData?._id || orderObjId || effectiveCategoryObjId}`}
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        categoryObjId={effectiveCategoryObjId}
        setActiveTab={handleTabSuper}
        orderPatientData={{
          ...(crownAndBridgeOrderDetails?.patientDetails ||
            normalizedOrderSnapshot?.patientDetails ||
            orderByIdData?.patientDetails ||
            {}),
          expectedDelivery:
            crownAndBridgeOrderDetails?.expectedDelivery ??
            normalizedOrderSnapshot?.expectedDelivery ??
            orderByIdData?.expectedDelivery,
          isPriority:
            crownAndBridgeOrderDetails?.isPriority ??
            normalizedOrderSnapshot?.isPriority ??
            orderByIdData?.isPriority,
        }}
        submitOrderData={submitPatientDetails}
      />
    ),
    [ORDER_STAGE.CASE_DETAILS]: (
      <CrownCaseDetailsSectionV2
        key={`case-${orderByData?._id || orderObjId || effectiveCategoryObjId}`}
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        categoryObjId={effectiveCategoryObjId}
        setActiveTab={handleTabSuper}
        orderCaseData={
          crownAndBridgeOrderDetails?.caseDetails ||
          normalizedOrderSnapshot?.caseDetails ||
          normalizeCaseDetails(orderByIdData) ||
          {}
        }
        submitOrderData={submitCaseDetails}
        selectedServiceCategory={selectedServiceCategory}
      />
    ),
    [ORDER_STAGE.UPLOAD_FILES]: (
      <UploadPhotoGraphsSectionV2
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        categoryObjId={effectiveCategoryObjId}
        setActiveTab={handleTabSuper}
        orderUploadData={crownAndBridgeOrderDetails?.uploadFiles}
        submitOrderData={submitUploadData}
        isFieldRequired={isFieldRequired}
      />
    ),
    [ORDER_STAGE.DISCLAIMER]: (
      <DisclaimerSectionV2
        orderObjId={orderByData?._id}
        orderByData={orderByData}
        categoryObjId={effectiveCategoryObjId}
        submitOrderData={submitDisclaimerForm}
        setActiveTab={handleTabSuper}
        tncList={crownTermsAndConditions}
        isTncChecked={isTncChecked}
        setIsTncChecked={setIsTncChecked}
        setDisclaimerFileUrl={setDisclaimerFileUrl}
        isDisclaimerFormValid={isDisclaimerFormValid}
      />
    ),
  };

  return (
    <>
      {isDisclaimerAccepted ? (
        <CrownOrderConfirmation
          userInfo={userInfo}
          userRole={userRole}
          orderObjId={orderByData?._id}
          orderFor={{ categoryObjId: effectiveCategoryObjId }}
          categoryObjId={effectiveCategoryObjId}
          setActiveTab={handleTabSuper}
          selectedServiceCategory={selectedServiceCategory}
          setIsDisclaimerAccepted={setIsDisclaimerAccepted}
          isOrderPlaced={isOrderPlaced}
          placeOrderHandler={placeOrderHandler}
          orderByData={orderByData}
        />
      ) : (
        <div className="MAIN-DASH bg-black md:p-4 px-4 pt-4 pb-20 w-full min-h-screen h-fit flex flex-col">
          <div className="NAVBAR flex justify-between items-center mb-4 ">
            <p className="text-[15px] text-[#999999] flex justify-between items-center">
              <img src={logo} className="mx-auto w-[50px] h-[40px] mr-4 block md:hidden" alt="" />
              <span>
                <img src={hut} alt="" />
              </span>
              <span className="ml-3">Dashboard</span>
            </p>
            <div className="flex gap-4 items-center">
              {isAuthenticated ? (
                <div className="text-[15px] justify-center items-center hidden md:flex text-white">
                  Hello, {userProfileDetails?.firstName ?? user?.name}
                </div>
              ) : (
                <LoginButton />
              )}
              {userRole !== "89uij7" ? (
                userInfo?.length > 0 ? (
                  <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                    {userInfo[0]?.active === 1 ? (
                      <>
                        {userInfo[0]?.crowdHireId}
                        <img className="relative top-[4px] right-0" src={greenTick} alt="" />
                      </>
                    ) : (
                      <div
                        className="flex"
                        data-tooltip-id="status"
                        data-tooltip-content={
                          "Your registration is under review and you will be notified once admin approves your registration."
                        }
                      >
                        <span className="text-orange-600">{userInfo[0]?.crowdHireId}</span>
                        <img
                          className="relative top-[0px] ml-2 right-0 h-5 w-5"
                          src={redCross}
                          alt=""
                        />
                        <Tooltip id="status" place="bottom" />
                      </div>
                    )}
                  </button>
                ) : (
                  <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                    Account Not Active
                    <img className="relative top-[0px] right-0 h-5 w-5" src={redCross} alt="" />
                  </button>
                )
              ) : (
                <></>
              )}

              <Notification />
            </div>
          </div>
          <div className="flex items-center justify-between mb-2">
            <p className="font-medium text-[34px] text-white">Dental Restoration Order </p>
            {priceRange && (
              <PriceSlip
                priceFrom={priceRange?.priceRangeFrom}
                priceTo={priceRange?.priceRangeTo}
                small={true}
              />
            )}
            {orderByData?.orderNumber && (
              <p className="text-white">
                Order Id : <strong className="text-primary">{orderByData?.orderNumber}</strong>
              </p>
            )}
          </div>
          <div className="ORDER-DETAIL-COMPONENT flex-1 flex flex-col h-full rounded-xl">
            <div className="bg-backgroundV2 flex flex-row flex-wrap items-center gap-4 md:justify-around justify-between md:px-0 px-4 py-4 mb-4">
              <div className="flex items-center gap-4">
                <div className="bg-[#8ED259] h-8 w-8 rounded-full text-white font-medium flex items-center justify-center">
                  <AiOutlineCheck />
                </div>
                <p className="font-semibold text-white md:block hidden ">Service Details</p>
              </div>
              <div className="md:w-[200px] h-[20px] ">
                <FaAngleRight className="mx-auto text-[#8ED259] text-xl md:rotate-0 " />
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-orange-500 h-8 w-8 rounded-full border text-white font-medium flex items-center justify-center">
                  2
                </div>
                <p className="text-white font-semibold md:block hidden ">Order Details</p>
              </div>
              <div className="md:w-[200px] h-[20px] md:rotate-0 ">
                <FaAngleRight className="mx-auto text-white " />
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-white h-8 w-8 rounded-full border text-[#999] font-medium flex items-center justify-center">
                  3
                </div>
                <p className="text-white md:block hidden ">Confirmation</p>
              </div>
            </div>
            <div className="TAB-SECTION flex-1 flex md:flex-row flex-col p-4 h-full bg-secondary">
              <ul className="NAV md:pr-8 flex flex-col items-start md:gap-4 gap-0 text-[16px] leading-4 font-medium md:border-r border-b border-[#222026] border-opacity-10">
                {tabNamesArray.map((title, i) => {
                  return (
                    <li
                      key={"tabs" + i}
                      className="relative w-full"
                      onClick={() => {
                        if (orderFormLastProgressTab >= i) {
                          handleTabSuper(title);
                        }
                      }}
                    >
                      <div
                        className={
                          activeTab === title
                            ? "text-white bg-primary w-full p-4 rounded-lg"
                            : "hover:text-white hover:bg-primary cursor-pointer text-white font-normal w-full p-4 rounded-lg"
                        }
                      >
                        {title}
                      </div>
                    </li>
                  );
                })}
              </ul>

              <div className="outlet flex flex-col flex-1 overflow-visible w-full md:py-4 md:pl-8  md:pr-4 p-2 ">
                {Object.keys(outputObject).map((key) => {
                  if (tabNamesArray.includes(key)) {
                    return (
                      <Fragment key={"tab-name" + key}>
                        {activeTab === key ? <>{outputObject[key]}</> : null}
                      </Fragment>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
